import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { post } from "../../services/ApiService";
import dayjs from "dayjs";

const InquiryActionModal = ({ isOpen, onClose, actionType, id, onSuccess }) => {
  const [formData, setFormData] = useState({
    shippingCarrierName: "",
    shippingDate: "",
    trackingNumber: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        shippingCarrierName: "",
        shippingDate: "",
        trackingNumber: "",
        message: "",
      });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      let endpoint = "";
      let body = {};

      if (actionType === "shipment") {
        const { shippingCarrierName, shippingDate, trackingNumber } = formData;
        if (!shippingCarrierName || !shippingDate || !trackingNumber) {
          toast.error("Please fill out all shipment fields.");
          setIsSubmitting(false);
          return;
        }
        endpoint = `api/inquiries/${id}/provide_shipment_info`;
        body = {
          shippingCarrierName,
          shippingDate: dayjs(shippingDate).format("YYYY-MM-DD"),
          trackingNumber,
        };
      } else if (actionType === "message") {
        if (!formData.message.trim()) {
          toast.error("Please enter a message.");
          setIsSubmitting(false);
          return;
        }
        endpoint = `api/inquiries/${id}/send_message`;
        body = { message: formData.message };
      } else if (actionType === "refund") {
        endpoint = `api/inquiries/${id}/issue_refund`;
      } else if (actionType === "close") {
        endpoint = `api/inquiries/${id}/no_response_needed`;
      }
      await post(endpoint, body);
      toast.success("Action completed successfully.");
      onClose();
      onSuccess();
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const getModalTitle = () => {
    switch (actionType) {
      case "shipment":
        return "Provide Shipment Info";
      case "message":
        return "Send Message";
      case "refund":
        return "Issue Refund Confirmation";
      case "close":
        return "No Response Needed";
      default:
        return "";
    }
  };

  const renderFields = () => {
    switch (actionType) {
      case "shipment":
        return (
          <>
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Shipping Carrier Name"
                name="shippingCarrierName"
                value={formData.shippingCarrierName}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <input
                type="date"
                className="form-control"
                name="shippingDate"
                value={formData.shippingDate}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Tracking Number"
                name="trackingNumber"
                value={formData.trackingNumber}
                onChange={handleChange}
              />
            </div>
          </>
        );
      case "message":
        return (
          <div className="mb-3">
            <textarea
              className="form-control"
              rows="4"
              placeholder="Enter your message..."
              name="message"
              value={formData.message}
              onChange={handleChange}
            />
          </div>
        );
      case "refund":
        return <p>Are you sure you want to issue a refund for this inquiry?</p>;
      case "close":
        return <p>Are you sure you want to mark as no response needed?</p>;
      default:
        return null;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{getModalTitle()}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">{renderFields()}</div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className={`btn ${actionType === "refund" ? "btn-danger" : "btn-primary"}`}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : actionType === "refund" ? "Confirm" : "Send"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryActionModal;
